export default function percentage(input) {
  return Math.round(input * 100);
}



// WEBPACK FOOTER //
// ./src/helpers/percentage.js